export default __webpack_public_path__ + "static/media/about-hover.9521554a.svg";